import {Client} from "~/lib/models/client";

class AppSettings {
  private _clientUUID: string = null;
  private _hasClients: boolean = null;
  private _client: Client = null;

  public get clientUUID(): string {
    return this._clientUUID;
  }
  public set clientUUID(value: string) {
    this._clientUUID = value;
  }

  public get hasClients(): boolean {
    return this._hasClients;
  }
  public set hasClients(value: boolean) {
    this._hasClients = value;
  }

  public get client(): Client {
    return this._client;
  }
  public set client(value: Client) {
    this._client = value;
  }
}

export { AppSettings }
